import { WorldProp } from "../../common/src/world-edits";
import { PixelAsset, isFlatFamily } from "../../common/src/pixel-assets";
import { paintPixelSprite } from "./pixel-asset-art";

type Sprite = ReturnType<typeof paintPixelSprite> & { flat: boolean };
const cache = new Map<string, Sprite>();
const hashes = new WeakMap<PixelAsset, string>();
/** FNV-1a of the pixel data, computed once per asset object, so the cache key stays small. */
function pixelsHash(a: PixelAsset): string {
  let h = hashes.get(a);
  if (h) return h;
  let n = 0x811c9dc5;
  for (const s of [a.pixels, a.box.join(","), a.ax + "," + a.ay])
    for (let i = 0; i < s.length; i++)
      n = Math.imul(n ^ s.charCodeAt(i), 0x01000193) >>> 0;
  hashes.set(a, (h = n.toString(36)));
  return h;
}
/** The sprite of a prop, native foot anchor and pixel density, in the editor and the game alike.
 *  `flat` props are painted into the scene ground; the others stand up and sort by their feet. */
export function worldPropSprite(
  p: Pick<WorldProp, "assetId" | "flip" | "rotation">,
  assets: PixelAsset[],
): Sprite {
  const asset = assets.find((a) => a.id === p.assetId);
  if (!asset) throw Error("Prop references a missing asset.");
  const key = `${asset.id}:${pixelsHash(asset)}:${p.flip ? 1 : 0}:${p.rotation ?? 0}`,
    hit = cache.get(key);
  if (hit) return hit;
  const sprite: Sprite = {
    ...paintPixelSprite(asset, !!p.flip, p.rotation ?? 0),
    flat: isFlatFamily(asset.recipe.family),
  };
  if (cache.size >= 128) cache.delete(cache.keys().next().value!);
  cache.set(key, sprite);
  return sprite;
}
